import EntityContentRepeaterItem from './EntityContentRepeaterItem';

export default EntityContentRepeaterItem;
